import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "data",
      description: "radio group 数据",
      type: "Array",
      required: "true"
    },
    {
      prop: "type",
      description: "样式",
      type: "String",
      available: "button,round",
      default: "round"
    },
    {
      prop: "size",
      description: "尺寸,round单选只有default, small",
      type: "String",
      available: "large, default, middle, small, mini",
      default: "default"
    },
    {
      prop: "space",
      description: "radio之间的间距",
      type: "Number",
      default: "30"
    },
    {
      prop: "vertical",
      description: "是否垂直展示,只对round有效",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "allowNull",
      description: "是否允许null，允许后可点击已选择的属性取消选择",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "disabled",
      description: "radio整体禁用",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "border",
      description: "是否含有border，只有当type为button时才生效",
      type: "Boolean",
      default: "false"
    }
  ],
  events: [
    {
      name: "change",
      description: "radio改变事件",
      argument: "value"
    },
    {
      name: "select",
      description: "radio点选事件",
      argument: "value"
    }
  ],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
